export const baseURL = "https://admin.almasachatapp.chat/";
export const key = "bdgr1SU67uBN8W160OCHybxwGMa24h1oXXOV3qjP";
export const projectName = "AlmasaChat";
